module.exports = "<div   class=\"loader\" *ngIf=\"loading\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/utils/loading/loading/loading.component.html
// module id = ./src/app/shared/utils/loading/loading/loading.component.html
// module chunks = main